import styled from 'styled-components'

const ReadonlyAudioNativeComponent = styled.audio`
  width: 100%;
`

ReadonlyAudioNativeComponent.displayName = 'ReadonlyAudioNativeComponent'
export default ReadonlyAudioNativeComponent
